import { blobResponse } from "Components/constants/Common";
import { ADD_PROFORMA, PROFORMA_DETAIL, PROFORMA_LIST, PROFORMA_PDF, WORK_ORDER_DATA, WORK_ORDER_PROFORMA } from "./ApiRoutes";
import { authData } from "./services";

export const addProformaApi = async (data: object) => {
  const response = await authData.post(ADD_PROFORMA, data);
  return response?.data;
};
export const listOfProformaApi = async (data: object) => {
  const response = await authData.post(PROFORMA_LIST, data);
  return response?.data;
};
export const viewProformaApi = async (id: number) => {
  const response = await authData.get(`${PROFORMA_DETAIL}${id}`);
  return response?.data;
};
export const editProformaAPi = async (id: number,data:object) => {
  const response = await authData.put(`${PROFORMA_DETAIL}${id}`,data);
  return response?.data;
};
export const workOrderDataApi = async (id: number) => {
  const response = await authData.get(`${WORK_ORDER_DATA}/${id}`);
  return response?.data;
};
export const proformaPdfApi = async (id: number) => {
  const response = await authData.get(`${PROFORMA_PDF}${id}`, blobResponse);
  return response;
};
export const workOrderProformaApi = async () => {
  const response = await authData.get(WORK_ORDER_PROFORMA);
  return response?.data;
};